import React from 'react';
import PropTypes from 'prop-types';
import Hyperlink from '../Hyperlink';

/**
 * The TOTAL block that closes every checkout step: label, the price large, the «Se orderdetaljer» link that
 * opens the OrderDetailsPanel.
 */
const TotalBlock = ({ label, price, linkLabel, onDetails }) => (
  <div className="checkout__total">
    <span className="checkout__total-label typo-h6">{label}</span>
    <span className="checkout__total-price typo-h2">{price}</span>
    {linkLabel && onDetails ? (
      <Hyperlink
        variant="small"
        className="checkout__total-link"
        onClick={(e) => {
          e.preventDefault();
          onDetails();
        }}
      >
        {linkLabel}
      </Hyperlink>
    ) : null}
  </div>
);

TotalBlock.propTypes = {
  label: PropTypes.node.isRequired,
  price: PropTypes.node.isRequired,
  linkLabel: PropTypes.node,
  onDetails: PropTypes.func,
};

export default TotalBlock;
